import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import {
  fetchStudentSubjects,
  deleteStudentSubject,
  addToFavorites,
} from '../../redux/actions/studentSubjectsActions';
import { fetchFormDatas } from '../../redux/actions/periodoActions';
import { SidebarProps } from '../../shared/prop-types/ReducerProps';
import Confirm from '../../shared/components/Confirm';
import {
  createErrorMessage,
  createWarningMessage,
  createSuccessMessage,
} from '../../helpers/notification';
import { getCurrentUser } from '../../helpers/storage';
import { Roles } from '../../constants/enums';

class StudentSubjectsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    const user = getCurrentUser();
    // const adminInscripcion = user.esFuncionario || user.esAdmin;
    const adminInscripcion = user.esAdmin;
    this.state = {
      adminInscripcion,
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
      periodos: [],
    };
    this.columns = [
      {
        key: 'mostrarEnTablero',
        name: 'Tablero',
        width: '80px',
        search: false,
        visible: this.showStarIcon(user),
        icon: {
          callback: row => (this.onAddToFavoritesSubmit(row)),
          component: row => (
            <span
              className={row.mostrarEnTablero ? 'fa fa-star' : 'fa fa-star-o'}
              title={row.mostrarEnTablero ? 'Quitar del tablero' : 'Mostrar en el tablero'}
            />
          ),
        },
      },
      {
        key: 'nombreAlumno',
        name: 'Alumno',
        search: false,
        visible: this.showNombre(user),
      },
      {
        key: 'nombre',
        name: 'Nombre del alumno',
        search: this.showNombre(user),
        visible: false,
      },
      {
        key: 'apellido',
        name: 'Apellido del alumno',
        search: this.showNombre(user),
        visible: false,
      },
      {
        key: 'codigoMateria',
        name: 'Codigo Materia',
        search: true,
        visible: false,
      },
      {
        key: 'periodo',
        name: 'Periodo',
        search: true,
        visible: true,
        className: 'text-center',
        width: '260px',
        type: 'select',
        searchProps: {
          options: this.getPeriodos,
        },
        format: row => `${row.periodo ? row.periodo.label : '-'}`,
      },
      {
        key: 'nombreMateria',
        name: 'Materia',
        format: row => `${row.codigoMateria} - ${row.nombreMateria}-${row.seccion}`,
        search: false,
        width: '300px',
      },
      {
        key: 'materia',
        name: 'Materia',
        search: true,
        visible: false,
      },
      {
        key: 'malla',
        name: 'Malla',
        width: '160px',
        search: true,
        format: row => row.nombreMalla,
      },
      {
        key: 'carrera',
        name: 'Carrera',
        width: '160px',
        search: true,
        visible: false,
        format: row => row.nombreCarrera,
      },
      {
        key: 'numeroSemestre',
        name: 'Semestre',
        type: 'number',
        search: true,
        format: row => `${row.numeroSemestre}º`,
        width: '70px',
        className: 'text-center',
      },
      {
        key: 'porcentajeAsistencia',
        name: '% Asistencia',
        width: '110px',
        className: 'text-center',
      },
      {
        key: 'porcentajePP',
        name: '% PP',
        width: '80px',
        className: 'text-center',
      },
      {
        key: 'tareasPendientes',
        name: 'Tareas',
        type: 'number',
        search: false,
        format: ({ id, cantidadTareas = 0 }) => {
          if (!id) {
            return <></>;
          }

          return (
            <h4>
              <Link
                title="Ver tareas"
                className={`btn-sm btn-${cantidadTareas > 0 ? 'primary' : 'secondary'}`}
                to={`/pages/student-tasks/${id}`}
              >
                {cantidadTareas}
              </Link>
            </h4>
          );
        },
        width: '70px',
        className: 'text-center',
      },
      {
        key: 'actions',
        name: 'Accion',
        width: '85px',
        visible: true,
        className: 'text-center',
      },
    ];
  }

  componentDidMount() {
    this.fetchDatasList({ periodo: {} });
  }

  fetchDatasList = (filters) => {
    this.setState({
      loading: true,
    });

    fetchFormDatas({
      onSuccess: ({ periodos }) => {
        this.setState({
          periodos,
          loading: false,
        });

        const { page, pageSize } = this.state;
        this.updateSubjectsTable(page, pageSize, filters);
      },
      onError: (error) => {
        console.log(error);
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  getViewPageAs = () => {
    const { sidebar: { viewPageAs } } = this.props;
    return viewPageAs;
  }

  showStarIcon = (user) => {
    const viewAsAlumno = this.getViewPageAs() === Roles.Alumno;
    return (user.esAlumno && !user.esAdmin) || (user.esAlumno && user.esAdmin && viewAsAlumno);
  }

  showNombre = (user) => {
    const viewAsAllowedUser = [Roles.Admin, Roles.Funcionario].includes(this.getViewPageAs());
    return (user.esAdmin || user.esFuncionario) && viewAsAllowedUser;
  }

  updateSubjectsTable = (page, pageSize, filters = { periodo: {}, numeroSemestre: 0 }) => {
    const {
      periodo = { value: 0, label: '-' },
      numeroSemestre = 0,
    } = filters;

    const params = {
      ...filters,
      numeroSemestre: Number(numeroSemestre),
      periodoId: periodo.value,
    };

    this.setState({
      loading: true,
      page,
      pageSize,
      filters: params,
    });

    const { sidebar: { viewPageAs } } = this.props;
    fetchStudentSubjects(
      viewPageAs !== 0,
      {
        pageInfo: {
          page,
          pageSize,
          filters: params,
        },
        onSuccess: (pageInfo) => {
          this.setState({
            loading: false,
            items: pageInfo.items,
            totalItemsCount: pageInfo.totalItemsCount,
            enableInscription: pageInfo.enableInscription,
          });
        },
        onError: (error) => {
          if (error && error.type === 'warning') {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Error al intentar cargar la lista de materias');
          }

          this.setState({ items: [], loading: false });
        },
      },
    );
  }

  handleDeleteSubject = (inscription) => {
    const name = `${inscription.codigoMateria}- ${inscription.nombreMateria}`;
    Confirm({
      title: 'Borrar inscripción',
      question: `Estás seguro que deseas eliminar la inscripción a ${name}?`,
      yesLabel: 'Si, Borrar inscripción',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteStudentSubject(inscription.id, {
          onSuccess: () => {
            createSuccessMessage('Inscripción borrada exitosamente');
            const { page, pageSize } = this.state;
            this.updateSubjectsTable(page, pageSize);
          },
          onError: (error) => {
            if (error.message) {
              createWarningMessage(error.message);
            } else {
              createErrorMessage('Error al intentar borrar la inscripción');
            }
          },
        });
      },
    });
  };

  editStudentSubject = (student) => {
    const { history } = this.props;
    history.push(`/pages/student-subjects/edit/${student.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateSubjectsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateSubjectsTable(1, pageSize, values);
    }
  };

  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateSubjectsTable(1, pageSize, {});
  };

  getGridActions = (key, obj) => {
    const { adminInscripcion } = this.state;
    const { enableInscription } = obj;
    if (!(key === 'actions')) return null;
    const title = enableInscription ? '(Periodo cerrado)' : '';
    let disabledCss = '';

    if (!enableInscription) {
      disabledCss = adminInscripcion ? 'semi-disabled' : 'disabled';
    }

    const actions = [
      {
        key: 'edit',
        icon: <span className={`fa fa-edit ${disabledCss}`} title={`Editar inscripción ${title}`} />,
        callback: (student) => {
          if (enableInscription || adminInscripcion) this.editStudentSubject(student);
        },
      },
      {
        key: 'delete',
        icon: <span className={`fa fa-trash ${disabledCss}`} title={`Borrar inscripción ${title}`} />,
        callback: (student) => {
          if (enableInscription || adminInscripcion) this.handleDeleteSubject(student);
        },
      },
    ];

    if (!enableInscription) {
      const infoCss = adminInscripcion ? 'fa fa-warning' : 'fa fa-lock';
      actions.push({
        key: 'lock-icon',
        icon: <span className={`${infoCss}`} title="Periodo de inscripción finalizado" />,
        callback: () => false,
      });
    }

    return actions;
  }

  onAddToFavoritesSubmit = (inscription) => {
    if (inscription) {
      addToFavorites(inscription.id, {
        onSuccess: () => {
          const { items } = this.state;

          const newState = items.map(item => (
            item.id === inscription.id ? { ...item, mostrarEnTablero: !inscription.mostrarEnTablero } : item
          ));

          this.setState({
            items: newState,
          });

          createSuccessMessage(
            `Materia ${(!inscription.mostrarEnTablero ? 'agregada al' : 'quitada del')} tablero exitosamente`,
          );
        },
        onError: (error) => {
          if (error.message) {
            createWarningMessage(error.message);
          } else {
            createErrorMessage('Error al intentar quitar la materia del tablero ');
          }
        },
      });
    }
  };

  getPeriodos = () => {
    const { periodos = [] } = this.state;

    return periodos;
  };

  getButtonInscription = ({ viewPageAs, enableInscription, adminInscripcion }) => {
    if (viewPageAs === 0 && enableInscription) {
      return (
        <Link className="btn btn-primary" to="/pages/account/edit-profile">
          Inscribase Aqu&iacute;
        </Link>
      );
    }

    if (adminInscripcion) {
      return (
        <Link className="btn btn-primary" to="/pages/student-subjects/inscription/new">
          Nueva inscripción
        </Link>
      );
    }

    return null;
  };

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
      enableInscription,
      adminInscripcion,
    } = this.state;
    const { sidebar: { viewPageAs } } = this.props;

    if (loading) {
      return (
        <LoadingSpinner />
      );
    }

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Inscripciones a materias</h3>
            <div className="card__title">
              {
                this.getButtonInscription({ viewPageAs, enableInscription, adminInscripcion })
              }
            </div>
          </Col>
        </Row>
        <Row>
          <DataTable
            title="Listado de todas las materias del/los alumno(s)"
            columns={this.columns}
            items={items}
            onChangePage={this.onChangePage}
            page={page}
            pageSize={pageSize}
            totalItemsCount={totalItemsCount}
            getGridActions={(key, obj) => this.getGridActions(key, obj)}
            onSubmit={this.onDataTableSubmit}
            onClearFilters={this.onDataTableClearFilters}
            initialValues={filters}
            enableReinitialize
          />
        </Row>
      </Container>
    );
  }
}

StudentSubjectsContainer.propTypes = {
  sidebar: SidebarProps.isRequired,
};

export default withRouter(connect(state => ({
  sidebar: state.sidebar,
}))(StudentSubjectsContainer));
